import * as React from "react";
import { DropdownMenu } from "@radix-ui/themes";
import { toast } from "sonner";
import { TrashIcon } from "@radix-ui/react-icons";
import { useMutation } from "convex/react";
import { api } from "@repo/convex/convex/_generated/api";
import { Doc } from "@repo/convex/convex/_generated/dataModel";
import { useOptimisticTrashItem } from "../../hooks.ts";

interface Props {
  item: Doc<"items">;
  onTrashed?: () => unknown;
}

export const TrashItemMenuItem: React.FC<Props> = ({ item, onTrashed }) => {
  const trash = useOptimisticTrashItem();
  const restore = useMutation(api.items.restoreMine);
  return (
    <DropdownMenu.Item
      color="red"
      onClick={() =>
        trash({ itemId: item._id })
          .then(() => {
            onTrashed?.();
            toast("Moved to the trash", {
              action: { label: "Undo", onClick: () => restore({ itemId: item._id }).catch(toast.error) },
            });
          })
          .catch(toast.error)
      }
    >
      <TrashIcon />
      Move to the trash
    </DropdownMenu.Item>
  );
};
